module.exports = __webpack_public_path__ + "static/media/news-default.4c6ad1c7.png";